<template>
  <div class="main-content" ref="DOM">
    <!-- <img src="./images/1.png" />
    <img src="./images/2.3.png" />
    <img src="./images/button.png" class="img-1" v-show="btnShow" />
    <img src="./images/button2.png" class="img-1" v-show="!btnShow" />
    <img src="./images/3.png" />
    <img src="./images/4.2.png" id="input" />
    <img src="./images/diantihaibaos.png" v-if="utm_source==='fenzhong' && utm_medium==='diantihaibaos'"/>
    <img src="./images/jinritoutiao.png" v-else-if="utm_source==='TOUTIAO' && utm_medium==='jinritoutiao'"/>
    <img src="./images/douyinduanshipin.png" v-else-if="utm_source==='TOUTIAO' && utm_medium==='douyinduanshipin'"/>
    <img src="./images/kaiping.png" v-else-if="utm_source==='GoFunAPP' && utm_medium==='kaiping'"/>
    <img src="./images/banner.png" v-else-if="utm_source==='website' && utm_medium==='banner'"/>
    <img src="./images/gonghao.png" v-else-if="utm_source==='weixin' && utm_medium==='gonghao'"/>
    <img src="./images/other.png" v-else />
    <img src="./images/5.1.png" />
    <img src="./images/6.1.png" />
    <a class="btn-1" href="#input" @click="goInput"></a>
    <button class="btn-2" @click="goGoFunCome"></button>
    <button class="btn-3" @click="goGetVouchers"></button>
    <input
      type="text"
      class="input-1"
      v-model.trim="name"
      @keyup="btKeyUp"
      maxlength="5"
      placeholder="您的姓名"
    />
    <p class="mode-1" v-show="!carType">您的爱车品牌与车型</p>
    <button class="input-1 input-2" @click="goBrand">{{ carType }}</button>
    <input
      type="text"
      class="input-1 input-3"
      maxlength="11"
      v-model.trim="phone"
      @keyup="checkPhone"
      placeholder="您的手机号"
    />
    <input
      type="text"
      class="input-1 input-4"
      v-model.trim="code"
      @keyup="checkCode"
      maxlength="6"
      placeholder="请输入验证码"
    />
    <button class="btn-4" @click="getCode">{{ codeText }}</button>
    <a v-show="bottomBtnShow" class="btn-5" href="#input" @click="goInput"
      ><img src="./images/7.png"
    /></a>
    <button class="btn-6" @click="supplyCarOwner"></button> -->
  </div>
</template>

<script>
import { addSensorsTrack } from "@/libs/utils";
import { sendSmsCode, becomeOwner, h5TransferDataBack } from "@/services/C2C";
import sensors from "sa-sdk-javascript";
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
export default {
  name: "landPage",
  data() {
    return {
      name: "",
      carType: "",
      phone: "",
      code: "",
      bottomBtnShow: false,
      codeText: "获取验证码",
      time: 60,
      btnShow: true,
      interval: "",
      utm_source: "",
      utm_medium: ""
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    Toast.fail({
      message: "活动已下架",
      duration: 0
    });
    const locationUrlStr = window.location.href;
    const urlSearch = locationUrlStr.split("?");
    console.warn("urlSearch:",urlSearch);
    if (urlSearch.length > 1) {
      const paramsArr = urlSearch[1].split("&");
      const pfType = paramsArr[0].split("=");
      console.warn("pfType:",pfType);
      if (pfType[0] === "utm_source" && pfType[1]) {
        console.warn("updateLdUrl:",locationUrlStr);
        this.$store.commit("updateLdUrl");
      }
    }
    window.addEventListener("scroll", this.btn_pos);
    if (this.$route.query.brandName) {
      this.carType =
        this.$route.query.brandName + "-" + this.$route.query.modelName;
    }
    if (this.$route.query.scrollTop > 0) {
      document.body.scrollTop = this.$route.query.scrollTop;
      document.documentElement.scrollTop = this.$route.query.scrollTop;
    }
    this.name = this.$route.query.name;
    this.phone = this.$route.query.phone;
    this.code = this.$route.query.code;
    this.utm_source = this.$route.query.utm_source;
    this.utm_medium = this.$route.query.utm_medium;
    this.interval = setInterval(() => {
      this.btnShow = !this.btnShow;
    }, 300);
  },
  methods: {
    btKeyUp(e) {
      this.name = e.target.value.replace(/[^\u4E00-\u9FA5]/g, "");
    },
    checkPhone(e) {
      this.phone = e.target.value.replace(/[^0-9]/g, "");
    },
    checkCode(e) {
      this.code = e.target.value.replace(/[^0-9]/g, "");
    },
    btn_pos() {
      const scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop <= 1048) {
        this.bottomBtnShow = false;
      } else {
        this.bottomBtnShow = true;
      }
    },
    //跳转1元2小时特惠用车页面
    goGoFunCome() {
      addSensorsTrack("webCustomButtonClick", {
        $element_content: "wyyc",
        $url: window.location.href
      });
      window.location.href =
        "https://app5.shouqiev.com/dist/#/GoFunCome?/utm_source=c2c";
    },
    //跳转领取洗车券
    goGetVouchers() {
      addSensorsTrack("webCustomButtonClick", {
        $element_content: "wscz",
        $url: window.location.href
      });
      this.$router.push({
        path: "/C2C/car-service?/utm_source=c2c"
      });
    },
    //选择品牌
    goBrand() {
      const scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.$router.push({
        path: "/C2C/car-brand",
        query: {
          name: this.name,
          phone: this.phone,
          code: this.code,
          scrollTop: scrollTop,
          utm_source: this.$route.query.utm_source,
          utm_medium: this.$route.query.utm_medium
        }
      });
    },
    goInput() {
      addSensorsTrack("webCustomButtonClick", {
        $element_content: "wyxctgzq",
        $url: window.location.href
      });
    },
    //获取验证码
    getCode() {
      if (this.time < 60) {
        return false;
      }
      if (!this.phone) {
        this.$toast("请输入手机号");
        return false;
      }
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (!reg.test(this.phone)) {
        this.$toast("请输入正确的手机号");
        return false;
      }
      const interval = setInterval(() => {
        if (this.time === 0) {
          this.codeText = "获取验证码";
          this.time = 60;
          clearInterval(interval);
        } else {
          this.time--;
          this.codeText = this.time + "秒后重发";
        }
      }, 1000);

      const data = "phoneNum=" + this.phone + "&source=1";

      sendSmsCode(data).then(res => {
        if (res.code !== 200) {
          this.$toast(res.message);
        }
      });
    },
    //申请成为车主
    supplyCarOwner() {
      if (!this.name) {
        this.$toast("请输入您的姓名");
        return false;
      }
      if (!this.carType) {
        this.$toast("请选择品牌车型");
        return false;
      }
      if (!this.phone) {
        this.$toast("请输入手机号");
        return false;
      }
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (!reg.test(this.phone)) {
        this.$toast("请输入正确的手机号");
        return false;
      }
      if (!this.code) {
        this.$toast("请输入验证码");
        return false;
      }

      const data = {
        ownerName: this.name,
        ownerSim: this.phone,
        verifyCode: this.code,
        source: 1,
        brandId: this.$route.query.brandId,
        brandCodeName: this.$route.query.brandName,
        seriesId: this.$route.query.modelId,
        seriesCodeName: this.$route.query.modelName,
        channelId: this.$route.query.utm_source + "," + this.$route.query.utm_medium
      };
      console.warn("ldCurrentUrl:",this.$store.state.ldCurrentUrl)
      becomeOwner(data).then(res => {
        if (res.code === 200) {
          addSensorsTrack("webCustomButtonClick", {
            $element_content: "sqcwcz",
            $url: window.location.href
          });
          if (res.result.registerAction) {
            this.doTransferDataBack();
            setTimeout(()=>{
              this.$router.push({
                path: "/C2C/submit-success",
                query: {
                  userId: res.result.userId,
                  ownerSim: this.phone,
                  ownerName: this.ownerName,
                  brandId: this.$route.query.brandId,
                  seriesId: this.$route.query.modelId
                }
              });
            },300)
          } else {
            this.$toast("您已经提交过申请");
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    doTransferDataBack() {
      try {
        const ldUrl = this.$store.state.ldCurrentUrl;
        const urlSearch = ldUrl.split("?");
        console.warn("ldCurrentUrl", this.$store.state.ldCurrentUrl);
        if (urlSearch.length > 1) {
          const paramsArr = urlSearch[1].split("&");
          const pfType = paramsArr[0].split("=");
          console.warn("pfType:", pfType);
          if (pfType[0] === "utm_source" && pfType[1]) {
            const ett = new Date().getTime();
            const params = {
              pf: pfType[1].toLocaleUpperCase(),
              et: "form",
              ett: ett,
              ld: encodeURIComponent(ldUrl)
            };
            console.warn("params:", params);
            h5TransferDataBack(params);
          }
        }
      } catch (err) {
        console.warn(err);
      }
    }
  }
};
</script>

<style scoped lang="scss">
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-size: 25px;
  color: #b1a2e5;
  font-family: PingFangSC-Semibold;
}
::-moz-placeholder {
  /* Firefox 19+ */
  font-size: 25px;
  color: #b1a2e5;
  font-family: PingFangSC-Semibold;
}
:-ms-input-placeholder {
  /* IE 10+ */
  font-size: 25px;
  color: #b1a2e5;
  font-family: PingFangSC-Semibold;
}
:-moz-placeholder {
  /* Firefox 18- */
  font-size: 25px;
  color: #b1a2e5;
  font-family: PingFangSC-Semibold;
}
.main-content {
  width: 100%;
  height: auto;
  position: relative;
  img {
    width: 100%;
    float: left;
  }
  .img-1 {
    width: 662px;
    position: absolute;
    top: 1211px;
    left: 44px;
  }
  .btn-1 {
    position: absolute;
    width: 662px;
    height: 140px;
    left: 43px;
    top: 1211px;
    background: transparent;
    border: transparent;
    display: block;
  }
  .btn-2 {
    position: absolute;
    width: 316px;
    height: 153.5px;
    left: 44px;
    top: 1390px;
    background: transparent;
    border: transparent;
  }
  .btn-3 {
    position: absolute;
    width: 316px;
    height: 153.5px;
    right: 44px;
    top: 1390px;
    background: transparent;
    border: transparent;
  }
  .input-1 {
    position: absolute;
    width: 518px;
    height: 53px;
    line-height: 53px;
    left: 148px;
    top: 1663px;
    background: transparent;
    border: transparent;
    padding-left: 100px;
    box-sizing: border-box;
    font-family: PingFangSC-Semibold;
    font-size: 25px;
    color: #141e25;
    text-align: left;
  }
  .input-2 {
    top: 1751px;
  }
  .mode-1 {
    position: absolute;
    top: 1736px;
    left: 248px;
    color: #b1a2e5;
    font-size: 25px;
    font-weight: bolder;
  }
  .input-3 {
    top: 1839px;
  }
  .input-4 {
    top: 1927px;
  }
  .btn-4 {
    position: absolute;
    min-width: 150px;
    height: 33px;
    right: 84px;
    top: 1849px;
    background: transparent;
    border: transparent;
    font-family: MicrosoftYaHei;
    font-size: 25.01px;
    color: #6034ff;
    text-align: right;
    padding: 0;
  }
  .btn-5 {
    position: fixed;
    left: 0;
    bottom: 0;
  }
  .btn-6 {
    position: absolute;
    width: 662px;
    height: 140px;
    left: 43px;
    top: 2037px;
    background: transparent;
    border: transparent;
  }
}
</style>
